import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungOberhausen() {
  return (
    <CityPageTemplate
      city="Oberhausen"
      slug="oberhausen"
      intro="Oberhausen im Ruhrgebiet – wir beraten Dich digital und ohne versteckte Kosten."
      description="Unabhängige & digitale Finanzberatung für Oberhausen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
